export const COLOR_OPTIONS = [
  { value: 'W', label: 'White' },
  { value: 'U', label: 'Blue' },
  { value: 'B', label: 'Black' },
  { value: 'R', label: 'Red' },
  { value: 'G', label: 'Green' },
  { value: 'C', label: 'Colorless' },
  { value: 'M', label: 'Multicolor' },
];

export const RARITY_OPTIONS = [
  { value: 'common', label: 'Common' },
  { value: 'uncommon', label: 'Uncommon' },
  { value: 'rare', label: 'Rare' },
  { value: 'mythic', label: 'Mythic' },
];

export const CONDITION_OPTIONS = [
  { value: 'MINT', label: 'Mint' },
  { value: 'NM', label: 'Near Mint' },
  { value: 'LP', label: 'Lightly Played' },
  { value: 'MP', label: 'Moderately Played' },
  { value: 'HP', label: 'Heavily Played' },
  { value: 'DAMAGED', label: 'Damaged' },
];

export const TYPE_OPTIONS = [
  { value: 'Creature', label: 'Creature' },
  { value: 'Instant', label: 'Instant' },
  { value: 'Sorcery', label: 'Sorcery' },
  { value: 'Enchantment', label: 'Enchantment' },
  { value: 'Artifact', label: 'Artifact' },
  { value: 'Land', label: 'Land' },
  { value: 'Planeswalker', label: 'Planeswalker' },
];
